<template>
      <v-container>
    <v-layout wrap>
      <v-flex xs12>
          <v-layout row>
              <v-flex>
                <span class="headline">Environment details
                </span>
              </v-flex>
                    <v-spacer></v-spacer>
                    <v-btn class="success" small @click="()=>{$emit('manageEnvironments')}">Manage environments</v-btn>
          </v-layout>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                        <h2>Environment : {{tempEnvironment.name}}</h2>
                        </v-flex>
                    <v-flex xs12>
                        <h3>List of variables</h3>
                        </v-flex>
                    <v-flex xs12>
                      <v-data-table
                        hide-default-footer
                        :headers="[{ text: 'Name', align: 'left', sortable: false, value: 'name' }, { text: 'Value',sortable: false, name:'value'}]"
                        :items="tempEnvironment.variables"
                        class="elevation-1"
                      >
                        <template v-slot:item={item}>
                            <tr>
                          <td>{{item.name}}</td>
                          <td>{{item.value}}</td>
                            </tr>
                        </template>
                      </v-data-table>
                    </v-flex>

                  </v-layout>
                </v-container>
      </v-flex>
    </v-layout>
      </v-container>
</template>
<script>
  import FunctionService from './services/FunctionService'
export default {
    props:['environment','dialogVisibility'],
    data(){return{
        tempEnvironment : {}
    }},
    watch:{
      dialogVisibility(b,a){
        this.initialize()
      }
    },
    methods:{
        initialize(){
            console.log(this.environment)
          FunctionService.getEnvironment(this.environment).then(r=>{
          r.data.variables = _.map(r.data.variables,(value,key)=>{return {name:key,value:value}})
          this.tempEnvironment = Object.assign({}, r.data)
        }).catch(err=>{
          this.$store.commit('push', {msg: 'Error while getting environments (' + err +')', color: 'error'})
        })
        }
    },
    created() {
      this.initialize()
    },

}
</script>
